import React from 'react';
import Icon from '@pushpay/icon';
import { clsx, createUseStyles } from '@pushpay/styles';
const directionAngles = {
  up: '0deg',
  right: '90deg',
  down: '180deg',
  left: '-90deg'
};
const useStyles = createUseStyles({
  root: ({
    direction
  }) => ({
    transform: `rotate(${directionAngles[direction]})`
  })
});

const ArrowDoubleIcon = ({
  direction,
  classes: classesProp,
  className: classNameProp,
  ...rest
}) => {
  const classes = useStyles(classesProp, {
    direction
  });
  const className = clsx(classes.root, classNameProp);
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24",
    className: className
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.66c.59-.002 1.157.236 1.574.66l8.008 8.126c.57.598.555 1.551-.034 2.13a1.467 1.467 0 01-2.064 0l-7.335-7.444a.208.208 0 00-.297 0l-7.336 7.444a1.469 1.469 0 01-2.098-.035 1.52 1.52 0 010-2.095l8.008-8.127A2.205 2.205 0 0112 10.66zM12 2c.59 0 1.157.237 1.574.66l8.008 8.127c.57.598.555 1.551-.034 2.13a1.467 1.467 0 01-2.064 0l-7.335-7.444a.208.208 0 00-.297 0l-7.336 7.444a1.469 1.469 0 01-2.098-.035 1.52 1.52 0 010-2.095l8.008-8.127A2.205 2.205 0 0112 2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

export default ArrowDoubleIcon;